/**
 * PowerRole - Role para conversão de unidades de potência
 *
 * Implementa os 4 pilares: Convert, Cast, Validate, Format
 *
 * @example
 * const power = new PowerRole();
 * power.convert('horsepower_mechanical', 'kilowatt', 1)  // 0.7457
 * power.cast('watt', '100 W')                            // 100
 * power.validate('watt', 100)                            // { valid: true, errors: [] }
 * power.format('kilowatt', 2.5)                          // "2.5 kW"
 */

import { SimpleRole, type SimpleValidationConfig } from "../../contracts";
import { POWER_UNITS, POWER_ALIASES } from "./constants";

// =============================================================================
// POWER ROLE CLASS
// =============================================================================

export class PowerRole extends SimpleRole {
  readonly name = "power";
  readonly base = "watt";
  readonly units = POWER_UNITS;
  readonly aliases = POWER_ALIASES;

  readonly validation: SimpleValidationConfig = {
    min: 0,
    minError: "Power cannot be negative",
  };
}

// =============================================================================
// SINGLETON INSTANCE
// =============================================================================

/** Instância singleton da PowerRole */
export const powerRole = new PowerRole();
